import Plyr from "plyr";

export const youtubeVideoPlayer = (function ($) {

    function renderPlayer($el) {
        const videoId = $el.attr("data-youtube-video");
        if(videoId) {

            $el.attr("data-plyr-provider", "youtube");
            $el.attr("data-plyr-embed-id", videoId);
            const player = new Plyr($el, {
                youtube: {
                    noCookie: true,
                    rel: 0,
                    showinfo: 0,
                    iv_load_policy: 3,
                    modestbranding: 1
                },
                // iconUrl: ENV.themeUrl + '/assets/img/icons/play.svg'
            });

            // player.on('playing', () => {
            //     $el.addClass('is-playing');
            // })
        }
    }


    function init() {
        $("[data-youtube-video]").each(function(){
            renderPlayer($(this));
        })
    }

    return {
        init: init
    }

})(jQuery);